import React from "react";
import useStyles from "./TinySelect.styles";
import { useTheme } from "react-jss";

interface Props {
    value: string;
    options: string[];
    onChange(value: string): void;
}

export function TinySelect(props: Props) {
    const { options, onChange, value } = props;
    const theme = useTheme();
    const classes = useStyles({ theme });
    return (
        <select className={classes.select} value={value} onChange={(e) => onChange(e.target.value)}>
            {options.map((v) => (
                <option value={v} key={v}>
                    {v}
                </option>
            ))}
        </select>
    );
}
